import { TOKEN_NAME } from "./constDispatch";

// const APIBASE = "http://100.114.6.77:6002/api/";
// const APIBASE = "http://jimmypc:6002/api/";
// const APIBASE = "http://107.120.133.77:6002/api/";
const APIBASE = "https://admin.svietnamadventures.com/api/";
const RAG_APIBASE = "https://chatbot.svietnamadventures.com/api/v1/";
const GG_AUTH_LINK = APIBASE + "setting/auth";

const API_get_bookings_sample = async (callback) => {
  await fetch(APIBASE + "booking_sample", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_clone_bookings_sample = async (
  from_id,
  to_booking_number,
  callback
) => {
  await fetch(APIBASE + "booking_sample/clone_sample", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify({
      from_id: from_id.toString(),
      to_booking_number: to_booking_number.toString(),
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_search_bookings = async (textSearch, callback) => {
  await fetch(APIBASE + "booking/search", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify({ text: textSearch.toString() }),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_edit_booking_sample = async (id, data, callback) => {
  await fetch(APIBASE + "booking_sample/" + id, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_get_bookings = async (callback) => {
  await fetch(APIBASE + "booking", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_edit_booking = async (id, data, callback) => {
  await fetch(APIBASE + "booking/" + id, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_get_bookings_id = async (id, callback) => {
  await fetch(APIBASE + "booking/" + id, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_delete_bookings_id = async (id, callback) => {
  await fetch(APIBASE + "booking/" + id, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_delete_bookings_sample = async (id, callback) => {
  await fetch(APIBASE + "booking_sample/" + id, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_clone_bookings = async (from_id, to_booking_number, callback) => {
  await fetch(APIBASE + "booking/clone", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify({
      from_id: from_id.toString(),
      to_booking_number: to_booking_number.toString(),
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_get_activities = async (callback) => {
  await fetch(APIBASE + "activities", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};

const API_get_activities_simple = async (callback) => {
  await fetch(APIBASE + "activities/simple", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};

const API_get_activities_not_hide = async (callback) => {
  await fetch(APIBASE + "activities/nothidden", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};

const API_edit_activities = async (id, data, callback) => {
  await fetch(APIBASE + "activities/" + id, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};

const API_clone_activities = async (from_id, code, callback) => {
  await fetch(APIBASE + "activities/clone", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify({
      from_id: from_id.toString(),
      code: code,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};
const API_delete_activities = async (id, callback) => {
  await fetch(APIBASE + "activities/" + id, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_get_accommondation = async (callback) => {
  await fetch(APIBASE + "accommondation", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_edit_accommondation = async (id, data, callback) => {
  await fetch(APIBASE + "accommondation/" + id, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_clone_accommondation = async (from_id, code, callback) => {
  await fetch(APIBASE + "accommondation/clone", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify({
      from_id: from_id.toString(),
      code: code,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((data) => {
      console.log(data);
      callback(data);
    });
};

const API_delete_accommondation = async (id, callback) => {
  await fetch(APIBASE + "accommondation/" + id, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((data) => {
      console.log(data);
      callback(data);
    });
};

const API_login = async (username, password, callback) => {
  await fetch(APIBASE + "user/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      username: username.toString(),
      password: password.toString(),
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_changepassword = async (body, callback) => {
  await fetch(APIBASE + "user/", {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_AddUser = async (body, callback) => {
  await fetch(APIBASE + "user/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_ResetPassword = async (username, callback) => {
  await fetch(APIBASE + "user/resetpass/" + username, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_GetUser = async (callback) => {
  await fetch(APIBASE + "user", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_DelUser = async (username, callback) => {
  await fetch(APIBASE + "user/" + username, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_EditUser = async (body, callback) => {
  await fetch(APIBASE + "user/edit", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_get_vendor = async (callback) => {
  await fetch(APIBASE + "vendor", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        callback(data.data);
      } else {
        console.log(data.error);
        callback(null);
      }
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};

const API_get_vendor_att = async (id, callback) => {
  await fetch(APIBASE + "vendor/vendorgroup/" + id, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        callback(data.data);
      } else {
        console.log(data.error);
        callback(null);
      }
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};

const API_edit_vendor = async (id, data, callback) => {
  await fetch(APIBASE + "vendor/" + id, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_get_vendors_id = async (id, callback) => {
  await fetch(APIBASE + "vendor/" + id, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_delete_vendors_id = async (id, callback) => {
  await fetch(APIBASE + "vendor/" + id, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_get_vendorgroup = async (callback) => {
  await fetch(APIBASE + "vendorgroup", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        callback(data.data);
      } else {
        console.log(data.error);
        callback(null);
      }
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};

const API_edit_vendorgroup = async (id, data, callback) => {
  await fetch(APIBASE + "vendorgroup/" + id, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_delete_vendorgroup_id = async (id, callback) => {
  await fetch(APIBASE + "vendorgroup/" + id, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_clone_vendorgroup = async (from_id, to_code, callback) => {
  await fetch(APIBASE + "vendorgroup/clone", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify({
      from_id: from_id.toString(),
      to_code: to_code.toString(),
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_clone_vendor = async (from_id, to_code, callback) => {
  await fetch(APIBASE + "vendor/clone", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify({
      from_id: from_id.toString(),
      to_code: to_code.toString(),
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_create_vendor = async (data, callback) => {
  await fetch(APIBASE + "vendor", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_get_operating_summary = async (callback) => {
  await fetch(APIBASE + "operating/summary", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};

const API_get_operating_summary_booking_ref = async (booking_ref, callback) => {
  await fetch(APIBASE + "operating/summary/" + booking_ref, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};

const API_get_operating_booking_id = async (id, callback) => {
  await fetch(APIBASE + "operating/booking_id/" + id, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};

const API_confirm_operating = async (data, callback) => {
  await fetch(APIBASE + "operating/confirm", {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};

const API_delete_operating = async (id, callback) => {
  await fetch(APIBASE + "operating/" + id, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};

const API_edit_operating = async (id, data, callback) => {
  await fetch(APIBASE + "operating/" + id, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_create_operation = async (booking_id, callback) => {
  await fetch(APIBASE + "operating/create", {
    method: "POST",
    body: JSON.stringify({
      booking_id: booking_id,
    }),
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};

const API_regenerate_operation = async (booking_id, callback) => {
  await fetch(APIBASE + "operating/regenerate", {
    method: "POST",
    body: JSON.stringify({
      booking_id: booking_id,
    }),
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};

const API_add_manually_operation = async (data, callback) => {
  await fetch(APIBASE + "operating/", {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};

const API_get_currency_rate = async (callback) => {
  await fetch(APIBASE + "setting/", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};

const API_edit_currency_rate = async (id, data, callback) => {
  await fetch(APIBASE + "setting/" + id, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_gg_send_email = async (data, callback) => {
  await fetch(APIBASE + "setting/send-email", {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};

const API_get_all_mess = async (callback) => {
  await fetch(APIBASE + "messtool/", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};

const API_clone_mess = async (from_id, to_code, callback) => {
  await fetch(APIBASE + "messtool/clone", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify({
      from_id: from_id.toString(),
      to_code: to_code.toString(),
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_delete_mess = async (id, callback) => {
  await fetch(APIBASE + "messtool/" + id, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_edit_mess = async (id, data, callback) => {
  await fetch(APIBASE + "messtool/" + id, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_get_calendar_messages_tomorrow = async (query_string, callback) => {
  await fetch(APIBASE + "calendarmess/" + query_string, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(null);
    });
};

const API_apply_message_for_multiple_activities = async (data, callback) => {
  await fetch(APIBASE + "activities/message", {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_regen_tax_data = async (id, callback) => {
  await fetch(APIBASE + "tax/regenerate/" + id, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_edit_tax_data = async (id, data, callback) => {
  await fetch(APIBASE + "tax/update/" + id, {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_get_activities_tax = async (callback) => {
  await fetch(APIBASE + "activity_tax", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_edit_activities_tax = async (id, data, callback) => {
  await fetch(APIBASE + "activity_tax/" + id, {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

const API_clone_activities_tax = async (from_id, to_code, callback) => {
  await fetch(APIBASE + "activity_tax/clone", {
    method: "POST",
    body: JSON.stringify({ from_id: from_id, to_code: to_code }),
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem(TOKEN_NAME),
    },
  })
    .then((response) => response.json())
    .then((data) => {
      callback(data);
    })
    .catch((error) => {
      console.log(error);
      callback(error);
    });
};

// rag items
const API_get_rag_items = async (params, callback) => {
  let url = new URL(RAG_APIBASE + "rag");
  if (params.source) url.searchParams.append("source", params.source);
  if (params.type) url.searchParams.append("type", params.type);
  if (params.limit) url.searchParams.append("limit", params.limit);
  if (params.offset) url.searchParams.append("offset", params.offset);

  await fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.log(error);
      callback({ items: [], total: 0 });
    });
};

const API_create_rag_item = async (body, callback) => {
  await fetch(RAG_APIBASE + "rag", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.log(error);
      callback({ error: error.message });
    });
};

const API_update_rag_item = async (item_id, body, callback) => {
  await fetch(RAG_APIBASE + "rag/" + item_id, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.log(error);
      callback({ error: error.message });
    });
};

const API_delete_rag_item = async (item_id, callback) => {
  await fetch(RAG_APIBASE + "rag/" + item_id, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.log(error);
      callback({ error: error.message });
    });
};

const API_reembed_rag_items = async (ids, callback) => {
  let body = ids && ids.length > 0 ? { ids: ids } : {};
  await fetch(RAG_APIBASE + "rag/reembed", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.log(error);
      callback({ error: error.message });
    });
};

// system prompt
const API_get_system_prompt = async (callback) => {
  await fetch(RAG_APIBASE + "system-prompt", {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.log(error);
      callback({ error: error.message });
    });
};

const API_create_system_prompt = async (prompt, callback) => {
  await fetch(RAG_APIBASE + "system-prompt", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ prompt }),
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.log(error);
      callback({ error: error.message });
    });
};

const API_get_system_prompt_history = async (params, callback) => {
  let url = new URL(RAG_APIBASE + "system-prompt/history");
  if (params.limit) url.searchParams.append("limit", params.limit);
  if (params.offset) url.searchParams.append("offset", params.offset);

  await fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.log(error);
      callback({ items: [], total: 0 });
    });
};

const API_activate_system_prompt = async (version, callback) => {
  await fetch(RAG_APIBASE + "system-prompt/activate", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ version }),
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.log(error);
      callback({ error: error.message });
    });
};

// chat test
const API_chat_test_send = async (message, session_id, callback) => {
  let body = { message };
  if (session_id) body.session_id = session_id;

  await fetch(RAG_APIBASE + "chat/test", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.log(error);
      callback({ error: error.message });
    });
};

const API_chat_test_clear = async (session_id, callback) => {
  await fetch(RAG_APIBASE + "chat/test/" + session_id, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.log(error);
      callback({ error: error.message });
    });
};

// agents
const API_get_agents = async (callback) => {
  await fetch(RAG_APIBASE + "agents", {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.log(error);
      callback({ items: [], total: 0 });
    });
};

const API_create_agent = async (body, callback) => {
  await fetch(RAG_APIBASE + "agents", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.log(error);
      callback({ error: error.message });
    });
};

const API_update_agent = async (agent_id, body, callback) => {
  await fetch(RAG_APIBASE + "agents/" + agent_id, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.log(error);
      callback({ error: error.message });
    });
};

const API_delete_agent = async (agent_id, callback) => {
  await fetch(RAG_APIBASE + "agents/" + agent_id, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.log(error);
      callback({ error: error.message });
    });
};

// patterns
const API_get_patterns = async (params, callback) => {
  let url = new URL(RAG_APIBASE + "patterns");
  if (params.limit) url.searchParams.append("limit", params.limit);
  if (params.offset) url.searchParams.append("offset", params.offset);

  await fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.log(error);
      callback({ items: [], total: 0 });
    });
};

const API_create_pattern = async (body, callback) => {
  await fetch(RAG_APIBASE + "patterns", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.log(error);
      callback({ error: error.message });
    });
};

const API_update_pattern = async (group_id, body, callback) => {
  await fetch(RAG_APIBASE + "patterns/" + group_id, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.log(error);
      callback({ error: error.message });
    });
};

const API_delete_pattern = async (group_id, callback) => {
  await fetch(RAG_APIBASE + "patterns/" + group_id, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => response.json())
    .then((data) => callback(data))
    .catch((error) => {
      console.log(error);
      callback({ error: error.message });
    });
};

export {
  //booking
  API_get_bookings,
  API_clone_bookings,
  API_get_bookings_id,
  API_edit_booking,
  API_delete_bookings_id,
  API_search_bookings,
  // activities
  API_get_activities,
  API_get_activities_not_hide,
  API_edit_activities,
  API_clone_activities,
  API_delete_activities,
  API_get_activities_simple,
  // accommondation
  API_get_accommondation,
  API_edit_accommondation,
  API_clone_accommondation,
  API_delete_accommondation,
  //users
  API_login,
  API_changepassword,
  API_DelUser,
  API_ResetPassword,
  API_GetUser,
  API_AddUser,
  API_EditUser,
  //vendor
  API_get_vendor,
  API_clone_vendor,
  API_get_vendors_id,
  API_edit_vendor,
  API_delete_vendors_id,
  API_create_vendor,
  API_get_vendor_att,
  // vendorgroup
  API_get_vendorgroup,
  API_edit_vendorgroup,
  API_clone_vendorgroup,
  API_delete_vendorgroup_id,
  // operating
  API_get_operating_summary,
  API_get_operating_summary_booking_ref,
  API_get_operating_booking_id,
  API_confirm_operating,
  API_delete_operating,
  API_create_operation,
  API_regenerate_operation,
  API_add_manually_operation,
  API_edit_operating,
  // sample bookings
  API_get_bookings_sample,
  API_clone_bookings_sample,
  API_edit_booking_sample,
  API_delete_bookings_sample,
  // setting
  API_get_currency_rate,
  API_edit_currency_rate,
  // google
  API_gg_send_email,
  GG_AUTH_LINK,
  // messtool
  API_get_all_mess,
  API_clone_mess,
  API_delete_mess,
  API_edit_mess,

  // calendar mess
  API_get_calendar_messages_tomorrow,
  API_apply_message_for_multiple_activities,

  // tax
  API_regen_tax_data,
  API_edit_tax_data,
  // activities tax
  API_get_activities_tax,
  API_edit_activities_tax,
  API_clone_activities_tax,
  // rag
  API_get_rag_items,
  API_create_rag_item,
  API_update_rag_item,
  API_delete_rag_item,
  API_reembed_rag_items,
  // system prompt
  API_get_system_prompt,
  API_create_system_prompt,
  API_get_system_prompt_history,
  API_activate_system_prompt,
  // chat test
  API_chat_test_send,
  API_chat_test_clear,
  // agents
  API_get_agents,
  API_create_agent,
  API_update_agent,
  API_delete_agent,
  // patterns
  API_get_patterns,
  API_create_pattern,
  API_update_pattern,
  API_delete_pattern,
};
